module.exports = __webpack_public_path__ + "img/wffs.38eb56a0.png";